module.exports = __webpack_public_path__ + "img/icon_1_27.dd87ffd5.png";